import { Table } from "@mantine/core";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailQueueActionsCell } from "./HeldEmailQueueActionsCell";
import { HeldEmailQueueSelectionCell } from "./HeldEmailQueueSelectionCell";
import { HeldEmailQueueIdentityCells } from "./HeldEmailQueueIdentityCells";
import { HeldEmailQueueStatusCells } from "./HeldEmailQueueStatusCells";
import { HeldEmailSelectionModel } from "./heldEmailSelection";

export interface HeldEmailQueueRowModel {
  email: HeldEmailListItem;
  canRelease: boolean;
  selection: HeldEmailSelectionModel;
  onView: (heldEmailId: string) => void;
  onRelease: (heldEmailIds: string[]) => void;
  onCancel: (heldEmailIds: string[]) => void;
}

export function HeldEmailQueueRow({
  model,
}: {
  model: HeldEmailQueueRowModel;
}) {
  return (
    <Table.Tr>
      <HeldEmailQueueSelectionCell
        canRelease={model.canRelease}
        email={model.email}
        selection={model.selection}
      />
      <HeldEmailQueueIdentityCells email={model.email} />
      <HeldEmailQueueStatusCells email={model.email} />
      <HeldEmailQueueActionsCell model={model} />
    </Table.Tr>
  );
}
